import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth, UserButton } from '@clerk/clerk-react';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isSignedIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const navigationItems = [
    {
      label: 'Find Programs',
      path: '/institution-search',
      authRequired: false,
      icon: 'Search',
    },
    {
      label: 'Online Learning',
      path: '/online-learning',
      authRequired: false,
      icon: 'Video',
    },
    {
      label: 'Resources',
      path: '/resources',
      authRequired: false,
      icon: 'BookOpen',
    },
    {
      label: 'My Applications',
      path: '/user-dashboard',
      authRequired: true,
      icon: 'FileText',
    },
    {
      label: 'Apply Now',
      path: '/application-form',
      authRequired: true,
      icon: 'PenTool',
    },
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const handleAuthAction = () => {
    navigate('/user-login');
    setIsMobileMenuOpen(false);
  };

  const handleNavigation = (path, authRequired) => {
    if (authRequired && !isSignedIn) {
      navigate('/user-login');
    } else {
      navigate(path);
    }
    setIsMobileMenuOpen(false);
  };

  const visibleNavItems = navigationItems?.filter(
    (item) => !item?.authRequired || isSignedIn
  );

  return (
    <header className="fixed top-0 left-0 right-0 z-[100] bg-card shadow-warm transition-smooth">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            className="flex items-center gap-3 transition-smooth hover:opacity-80"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <div className="w-12 h-12 bg-primary/10 rounded-md flex items-center justify-center transition-smooth">
              <Icon name="GraduationCap" size={28} color="var(--color-primary)" />
            </div>
            <span className="text-xl font-heading font-semibold text-foreground">
              ChineseLangApp
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-2">
            {visibleNavItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path, item?.authRequired)}
                className={`
                  px-4 py-2 rounded-md transition-smooth font-medium text-[15px]
                  flex items-center gap-2
                  ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground hover:bg-muted'
                  }
                `}
              >
                <Icon name={item?.icon} size={18} />
                {item?.label}
              </button>
            ))}

            {isSignedIn ? (
              <div className="ml-2">
                <UserButton afterSignOutUrl="/" />
              </div>
            ) : (
              <Button
                variant="default"
                onClick={handleAuthAction}
                iconName="User"
                iconPosition="left"
                className="ml-2"
              >
                Login
              </Button>
            )}
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-md hover:bg-muted transition-smooth"
            aria-label="Toggle mobile menu"
          >
            <Icon
              name={isMobileMenuOpen ? 'X' : 'Menu'}
              size={24}
              color="var(--color-foreground)"
            />
          </button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="md:hidden bg-card border-t border-border">
          <nav className="px-6 py-4 space-y-2">
            {visibleNavItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path, item?.authRequired)}
                className={`
                  w-full px-4 py-3 rounded-md transition-smooth font-medium text-left
                  flex items-center gap-3
                  ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground hover:bg-muted'
                  }
                `}
              >
                <Icon name={item?.icon} size={20} />
                {item?.label}
              </button>
            ))}

            {isSignedIn ? (
              <div className="mt-4 flex items-center justify-center">
                <UserButton afterSignOutUrl="/" />
              </div>
            ) : (
              <Button
                variant="default"
                onClick={handleAuthAction}
                iconName="User"
                iconPosition="left"
                fullWidth
                className="mt-4"
              >
                Login
              </Button>
            )}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;